/* eslint-disable @next/next/no-css-tags */
import { Box, CircularProgress } from '@mui/material'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { LayoutProps } from '../../../../design/common/Layouts'
import { useEffect, useState } from 'react'
import { AutoraJS } from "./Autora"
import { bootstrap } from "../../_common/bootstrap"
import { useLayoutData } from '../../../../utils/contexts/LayoutContext'
import { LoadingScreenStyle, colorSetter, topBarAvailable } from '../../PartnerPortalLayout'

const AutoraLayout = ({ children }: LayoutProps) => {
  const { partnerSiteFull } = useLayoutData()
  const [mainColor, setMainColor] = useState<string>("#f4511e")
  const [secondaryColor, setSecondaryColor] = useState<string>("#000000")
  const [textColor, setTextColor] = useState<string>("#777777")
  const [titleColor, setTitleColor] = useState<string>("#000000")
  
  const TopBar = dynamic(() => import('./_layouts/TopBar/TopBar'))
  const BottomBar = dynamic(() => import('./_layouts/BottomBar/BottomBar'))
  const Header = dynamic(() => import('./_layouts/Header/Header'))
  const Footer = dynamic(() => import('./_layouts/Footer/Footer'))

  const setColors = () => {
    setMainColor(prevMainColor => {
      return colorSetter(partnerSiteFull, "mainColor") ?? prevMainColor
    })
    setSecondaryColor(prevSecondaryColor => {
      return colorSetter(partnerSiteFull, "secondaryColor") ?? prevSecondaryColor
    })
    setTextColor(prevTextColor => {
      return colorSetter(partnerSiteFull, "textColor") ?? prevTextColor
    })
    setTitleColor(prevTitleColor => {
      return colorSetter(partnerSiteFull, "titleColor") ?? prevTitleColor
    })
  }

  useEffect(() => {
    AutoraJS.init()
    bootstrap.init()
  }, [])

  useEffect(() => {
    setColors()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerSiteFull])

  return (
    <>
      <Head>
        <style>
          {`
            :root {
              --main-color: ${mainColor};
              --secondary-color: ${secondaryColor};
              --text-color: ${textColor};
              --title-color: ${titleColor};
            }
          `}
        </style>
        <link rel="stylesheet" type="text/css" href="/templates/AutoraTemplate/assets/css/style.min.css"></link>
        <link rel="stylesheet" type="text/css" href="/templates/AutoraTemplate/assets/css/shortcodes.min.css"></link>
      </Head>

      <Box id="layout-loader" sx={LoadingScreenStyle}>
        <CircularProgress color="inherit" />
      </Box>

      <div className="header-fixed page no-sidebar header-style-2 topbar-style-1">
        <div id="wrapper">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              {topBarAvailable(partnerSiteFull) ?
                <TopBar />
                : null
              }
              <Header />
            </div>
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap">
                <div id="site-content" className="site-content clearfix">
                  <div id="inner-content" className="inner-content-wrap">
                    <div className="page-content">{children}</div>
                  </div>
                </div>
              </div>
            </div>
            {topBarAvailable(partnerSiteFull) ?
              <Footer />
              : null}
            <BottomBar />
          </div>
        </div>
        <a id="scroll-top"></a>
      </div>
    </>
  )
}

export default AutoraLayout
